import React, { useState } from 'react';


import HeaderTwo from "../components/header/HeaderTwo";

import { Link } from 'react-router-dom';
import FooterTwo from "../components/footer/FooterTwo";
import Breadcrumb from "./Breadcrumb";


function ProjectThree() {
    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'Equipe' }
    ];
    return (
        <div className=''>

            <HeaderTwo />

            <Breadcrumb title="Equipe" breadcrumbs={breadcrumbs} />




            {/* team area start*/}
            <div className="rts-team-area rts-section-gap bg-team-color">
                <div className="container">
                    <div className="row g-5">
                        {/* team single start */}
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="team-single-one-start">
                                <div className="team-image-area">
                                    <Link to={'/team-details'}>
                                        <img
                                            src="assets/images/equipe/1.png"
                                            alt="Business_Team_single"
                                        />
                                        <div className="team-social">
                                            <div className="main">
                                                <i className="fal fa-plus" />
                                            </div>
                                            <div className="team-social-one">
                                                <i className="fab fa-youtube" />
                                                <i className="fab fa-twitter" />
                                                <i className="fab fa-instagram" />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="single-details">
                                    <Link to={'/team-details'}>
                                        <h5 className="title">Nome</h5>
                                    </Link>
                                    <p>Cargo </p>
                                </div>
                            </div>
                        </div>
                        {/* team single end */}
                        {/* team single start */}
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="team-single-one-start">
                                <div className="team-image-area">
                                    <Link to={'/team-details'}>
                                        <img
                                            src="assets/images/equipe/2.png"
                                            alt="Business_Team_single"
                                        />
                                        <div className="team-social">
                                            <div className="main">
                                                <i className="fal fa-plus" />
                                            </div>
                                            <div className="team-social-one">
                                                <i className="fab fa-youtube" />
                                                <i className="fab fa-twitter" />
                                                <i className="fab fa-instagram" />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="single-details">
                                    <Link to={'/team-details'}>
                                        <h5 className="title">Nome</h5>
                                    </Link>
                                    <p>Cargo </p>
                                </div>
                            </div>
                        </div>
                        {/* team single end */}
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="team-single-one-start">
                                <div className="team-image-area">
                                    <Link to={'/team-details'}>
                                        <img
                                            src="assets/images/equipe/3.png"
                                            alt="Business_Team_single"
                                        />
                                        <div className="team-social">
                                            <div className="main">
                                                <i className="fal fa-plus" />
                                            </div>
                                            <div className="team-social-one">
                                                <i className="fab fa-youtube" />
                                                <i className="fab fa-twitter" />
                                                <i className="fab fa-instagram" />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="single-details">
                                    <Link to={'/team-details'}>
                                        <h5 className="title">Nome</h5>
                                    </Link>
                                    <p>Cargo </p>
                                </div>
                            </div>
                        </div>
                        {/* team single start */}
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="team-single-one-start">
                                <div className="team-image-area">
                                    <Link to={'/team-details'}>
                                        <img
                                            src="assets/images/equipe/4.png"
                                            alt="Business_Team_single"
                                        />
                                        <div className="team-social">
                                            <div className="main">
                                                <i className="fal fa-plus" />
                                            </div>
                                            <div className="team-social-one">
                                                <i className="fab fa-youtube" />
                                                <i className="fab fa-twitter" />
                                                <i className="fab fa-instagram" />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="single-details">
                                    <Link to={'/team-details'}>
                                        <h5 className="title">Nome</h5>
                                    </Link>
                                    <p>Cargo </p>
                                </div>
                            </div>
                        </div>
                        {/* team single end */}
                        {/* team single start */}
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="team-single-one-start">
                                <div className="team-image-area">
                                    <Link to={'/team-details'}>
                                        <img
                                            src="assets/images/equipe/5.png"
                                            alt="Business_Team_single"
                                        />
                                        <div className="team-social">
                                            <div className="main">
                                                <i className="fal fa-plus" />
                                            </div>
                                            <div className="team-social-one">
                                                <i className="fab fa-youtube" />
                                                <i className="fab fa-twitter" />
                                                <i className="fab fa-instagram" />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="single-details">
                                    <Link to={'/team-details'}>
                                        <h5 className="title">Nome</h5>
                                    </Link>
                                    <p>Cargo </p>
                                </div>
                            </div>
                        </div>
                        {/* team single end */}
                        {/* team single start */}
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="team-single-one-start">
                                <div className="team-image-area">
                                    <Link to={'/team-details'}>
                                        <img
                                            src="assets/images/equipe/6.png"
                                            alt="Business_Team_single"
                                        />
                                        <div className="team-social">
                                            <div className="main">
                                                <i className="fal fa-plus" />
                                            </div>
                                            <div className="team-social-one">
                                                <i className="fab fa-youtube" />
                                                <i className="fab fa-twitter" />
                                                <i className="fab fa-instagram" />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="single-details">
                                    <Link to={'/team-details'}>
                                        <h5 className="title">Nome</h5>
                                    </Link>
                                    <p>Cargo </p>
                                </div>
                            </div>
                        </div>
                        {/* team single end */}
                    </div>
                </div>
            </div>
            {/* team area End */}






            <FooterTwo />

        </div>
    )
}

export default ProjectThree